import React, { useContext, memo } from 'react'
import I18n from 'APP/I18n'

import moment from 'moment'
import { PostContext } from 'APP/Lib/Context'
import Card from 'APP/Components/Chat/Card'

const VideoCall = () => {
  const { post } = useContext(PostContext)
  const subtitle = I18n.t('ConversationScreen.callStarted', {
    time: moment(post.create_at).format('LT'),
  })

  return <Card title={post.message} subtitle={subtitle} iconName="phone" />
}

export default memo(VideoCall)
